<div class="label" [style.width]="labelWidth()">
  {{ labelId() | translate }}
</div>
<div class="value">{{ value() }}</div>
@if(copyValue()) {
<button mat-mini-fab>
  <mat-icon [cdkCopyToClipboard]="value()">content_copy</mat-icon>
</button>
}